import React from "react";
import { Link } from "react-router-dom";
import { IoChevronForward, IoHelpBuoyOutline } from "react-icons/io5";
import { StarterKitHero } from "../../../components/Shopping/Main/StarterKitHero";
import { products } from "../../../components/Shopping/Prodcuts";
import "./shopping.css";

type KitShot = { src: string; alt: string; title: string; caption: string };

// First shot is the large feature tile; the rest sit beside it (below it on phones).
const KIT_SHOTS: KitShot[] = [
  {
    src: "/images/product/mug-and-bowl-still-image-old.jpeg",
    alt: "Copper 3D-printed mug and bowl side by side, with a phone in the mug",
    title: "Mug and bowl",
    caption: "Two printed tools that hold your phone for everyday reach-and-grasp drills.",
  },
  {
    src: "/images/product/mug-still-shot.jpeg",
    alt: "3D-printed mug with a phone inside showing the mRehab home screen",
    title: "Mug",
    caption: "Lift, tilt, and pour with the phone tracking each move.",
  },
  {
    src: "/images/product/bowl-still-shot.png",
    alt: "3D-printed bowl with a phone inside tracking a vertical bowl activity",
    title: "Bowl",
    caption: "Two-handed lifts with live rep counts on screen.",
  },
];

export default function ShoppingPage() {
  const kit = products[0];

  return (
    <main id="main" className="ui-page">
      <div className="ui-container">
        <nav className="ui-breadcrumb" aria-label="Breadcrumb">
          <Link to="/">Home</Link>
          <span aria-hidden>/</span>
          <span aria-current="page">Shop</span>
        </nav>
        {kit ? <StarterKitHero product={kit} /> : null}

        <section className="shop-kit" aria-labelledby="shop-kit-title">
          <div className="shop-kit-header">
            <span className="ui-section-label">What's in the kit</span>
            <h2 id="shop-kit-title">Printed tools built around your phone</h2>
          </div>
          <ul className="shop-kit-grid">
            {KIT_SHOTS.map((shot) => (
              <li className="shop-kit-item" key={shot.src}>
                <figure className="shop-kit-figure">
                  <div className="ui-media shop-kit-media">
                    <img src={shot.src} alt={shot.alt} loading="lazy" decoding="async" />
                  </div>
                  <figcaption className="shop-kit-caption">
                    <span className="shop-kit-caption-title">{shot.title}</span>
                    <span className="shop-kit-caption-text">{shot.caption}</span>
                  </figcaption>
                </figure>
              </li>
            ))}
          </ul>
        </section>

        <section className="ui-card shop-help" aria-labelledby="shop-help-title">
          <div className="ui-card-header">
            <IoHelpBuoyOutline aria-hidden />
            <div className="ui-card-header-text">
              <h2 id="shop-help-title">Need help choosing?</h2>
              <p>Ask about fit, fulfillment timing, or bulk orders.</p>
            </div>
          </div>
          <Link to="/contact" className="ui-list-row">
            <span className="ui-list-text">
              <span className="ui-list-label">Contact us</span>
              <span className="ui-list-desc">
                Send a message and we will reply by email.
              </span>
            </span>
            <span className="ui-list-trailing">
              <IoChevronForward aria-hidden />
            </span>
          </Link>
        </section>
      </div>
    </main>
  );
}
